import { useTranslation } from 'react-i18next';

export default function AccessDenied() {
  const [translate] = useTranslation();
  return (
    <div className="w-screen h-screen flex flex-col items-center justify-center">
      <div className="text-md text-red-400 mt-3" role="text-area-err-msg">
        {translate('ACCESS_DENIED')}
      </div>
    </div>
  );
}
